var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: "800", persistent: "" },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { attrs: { color: "primary", dark: "", flat: "" } },
            [
              _c("v-toolbar-title", [
                _vm._v("Participantes ativos " + _vm._s(_vm.totalUsers)),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.visibleToSeller
            ? [
                _vm.show
                  ? _c(
                      "UsersSellOut",
                      _vm._b(
                        {
                          attrs: {
                            apportionment: _vm.apportionment,
                            "apportionment-type": "participant",
                          },
                          on: { totalUsers: _vm.setTotalUsers },
                        },
                        "UsersSellOut",
                        _vm.$attrs,
                        false
                      )
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.show
                  ? _c(
                      "UsersSellOut",
                      _vm._b(
                        {
                          attrs: {
                            apportionment: _vm.apportionment,
                            "apportionment-type": "seller",
                          },
                          on: { totalUsers: _vm.setTotalUsers },
                        },
                        "UsersSellOut",
                        _vm.$attrs,
                        false
                      )
                    )
                  : _vm._e(),
              ]
            : [
                _vm.show
                  ? _c(
                      "UsersSellOut",
                      _vm._b(
                        {
                          attrs: {
                            apportionment: _vm.apportionment,
                            "apportionment-type": "participant",
                          },
                          on: { totalUsers: _vm.setTotalUsers },
                        },
                        "UsersSellOut",
                        _vm.$attrs,
                        false
                      )
                    )
                  : _vm._e(),
              ],
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "justify-end" },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", outline: "", large: "" },
                  on: { click: _vm.close },
                },
                [_vm._v("\n        Cancelar\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", large: "" },
                  on: { click: _vm.confirm },
                },
                [_vm._v("\n        Confirmar\n      ")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }